import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import { htmlDecode } from '../../helperFunctions';

export const OW_DETAILS_MAIN_IMG_ALT_TEXT_DEFAULT = 'NuRelm';
export const OW_DETAILS_CLIENT = 'CLIENT';
export const OW_DETAILS_ROLE = 'OUR ROLE';
export const OW_DETAILS_TECH_USED = 'TECHNOLOGIES USED';

//TODO Need to add the image ALT anywhere used, if != null

const DetailsOurWorkContent = ({ data }) => {
  const checkForMainImage = () => {
    const src = get(data, 'acf.featured_image.sizes.featured_hero', false);
    const altText = get(data, 'acf.better_featured_image.alt_text', OW_DETAILS_MAIN_IMG_ALT_TEXT_DEFAULT);

    if (src === null || src === false) return <div />;
    
    return <img src={src} alt={altText} />;
  }

  const renderTechnologies = () => {
    return data.acf.technologies.map((tech) => (
      <ul key={tech}>
        <li>
          <i className="fa fa-minus fa-lg"></i>{tech}
        </li>
      </ul>
    ));
  }

  const renderProjectType = () => {
    return data.acf.project_type.map((type) => (
      <ul key={type}>
        <li>
          <i className="fa fa-minus fa-lg"></i>
          {type}
        </li>
      </ul>
    ));
  }

  return (
    <div>
      <div className="details-image">
        {checkForMainImage()}
      </div>
      <div className="details-text">
        <Grid>
          <Row>
            <Col className="work-details-col" lg={9}>
              <div dangerouslySetInnerHTML={{ __html: data.content.rendered }} />
            </Col>
            <Col className="work-details-col" lg={3}>
              <h6>{OW_DETAILS_CLIENT}</h6>
              <p>{htmlDecode(data.title.rendered)}</p>
              <h6>{OW_DETAILS_ROLE}</h6>
              {renderProjectType()}
              <h6>{OW_DETAILS_TECH_USED}</h6>
              {renderTechnologies()}
            </Col>
          </Row>
        </Grid>
      </div>
    </div>
  );
};

export default DetailsOurWorkContent;
